// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__16k_L","choiceBoxes":"toolbarselects_choiceBoxes__2EkOZ","simpleField":"toolbarselects_simpleField__29mf9"};